export default {
  MOBILITY_CARD_TITLE: 'Mobility Packages',
  MOBILITY_CARD_COPY:
    'Mobility packages are providing %PLATFORM% with relocation details for employees. Please use this feature to update the relocation data.',
  MOBILITY_CARD_SUBTITLE: 'Upload mobility package',
  UPLOAD_FORM_BUTTON_TEXT: 'Browse',
  MOBILITY_UPLOAD_BUTTON: 'Upload',
};
